import React, { useMemo, useState } from "react";
import styles from '../styles/topMenu.module.scss'
import { useUserInfo } from "@/api/request";
import Icon from "@/wmCompoments/Icon";
import { useAuth } from "@/provides/authProvider";
import { useModal } from "@/modals/modalContext";
import { useLocation, useNavigate } from "react-router";
import Tabs from "@/wmCompoments/tabs";
import TabsButton from "@/wmCompoments/tabs/TabsButton";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

const TopMenu = () => {
    const { t } = useTranslation('mine')
    const { data } = useUserInfo()

    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { openModal } = useModal()

    const { logout } = useAuth()

    const menus = useMemo(() => {
        return [
            {
                icon: 'icon-mine-wallet',
                text: t('centralWallet'),
                iconClass: 'w-[19px]',
                path: '/mine/centralWallet',
                onClick: () => {
                    navigate('/mine/centralWallet')
                }
            },
            {
                icon: 'icon-mine-user',
                text: t('profile'),
                iconClass: 'w-[19px]',
                path: '/mine/personalInfo',
                onClick: () => {
                    navigate('/mine/personalInfo')
                }
            },
            {
                icon: 'icon-mine-account',
                text: t('accountManagement'),
                iconClass: 'w-[19px]',
                path: '/mine/accountManagement',
                onClick: () => {
                    navigate('/mine/accountManagement')
                }
            },
            {
                icon: 'icon-mine-invite',
                text: t('inviteFriends'),
                iconClass: 'w-[19px]',
                path: '/mine/inviteFriends',
                onClick: () => {
                    navigate('/mine/inviteFriends')
                }
            },
            {
                icon: 'icon-mine-bet',
                text: t("betOrderRecords"),
                iconClass: 'w-[19px]',
                path: '/mine/betOrderRecords',
                onClick: () => {
                    navigate('/mine/betOrderRecords')
                }
            },
            {
                icon: 'icon-mine-transfer',
                text: t('transferCenter'),
                iconClass: 'w-[19px]',
                path: '/mine/transferCenter',
                onClick: () => {
                    navigate('/mine/transferCenter')
                }
            },
            {
                icon: 'icon-mine-feedback',
                text: t('feedback'),
                iconClass: 'w-[19px]',
                path: ['/mine/feedback','/mine/myFeedback'],
                onClick: () => {
                    navigate('/mine/feedback')
                }
            },
            {
                icon: 'icon-mine-award',
                text: t('awardRecord'),
                iconClass: 'w-[19px] h-[20px]',
                path: '/mine/awardRecord',
                onClick: () => {
                    navigate('/mine/awardRecord')
                }
            },
            {
                icon: 'icon-mine-transaction',
                text: t('transactionRecord'),
                iconClass: 'w-[19px] h-[20px]',
                path: '/mine/transactionRecords',
                onClick: () => {
                    navigate('/mine/transactionRecords')
                }
            },
            {
                icon: 'icon-mine-message',
                text: t('messageCenter'),
                iconClass: 'w-[19px] h-[20px]',
                path: '/mine/messageCenter',
                onClick: ()=>{
                    navigate('/mine/messageCenter')
                }
            },
            // {
            //     icon: 'icon-mine-join',
            //     text: '代理合作',
            //     iconClass: 'w-[15px] h-[21px]',
            //     path: '/mine/join',
            // },
            {
                icon: 'icon-mine-exchange',
                text: t('walletExchange'),
                iconClass: 'w-[19px]',
                path: '/mine/walletExchange',
                onClick: () => {
                    navigate('/mine/walletExchange')
                }
            },
            {
                icon: 'icon-mine-amount',
                text: t('logout'),
                iconClass: 'w-[19px]',
                onClick: () => {
                    logout()
                }
            }
        ]
    }, [pathname])


    const activeTab = useMemo(()=>{
        return menus.findIndex((v)=>{
            if( typeof v.path === 'string') {
                return pathname?.includes(v.path ?? '')
            }else {
                return v.path?.includes(pathname)
            }
        })
    },[pathname,menus])

    //const [activeTab, setActiveTab] = useState('0')

    const handleCopy = (v) => {
        if(ut.copyBoard(v)) {
            Toast.show(t('copySuccess'))
        }
    }

    return <div className={styles.warpper}>
        <div className={styles.left}>
            <img src={data?.avatar} className={styles.avatar} onClick={()=>{
                openModal('avatar')
            }}/>
            <div className={styles.headerWarpper}>
                <div>{data?.name}</div>
                <div onClick={()=>{
                    handleCopy(data?.id)
                }}>
                    <span>{'ID：'}</span>
                    <span>{data?.id}</span>
                    <Icon name="icon-games-copy" className={styles.copy} />
                </div>
            </div>

        </div>


        <div className={styles.right}>
            <Tabs type={'line'}
            onClickTab={(key) => {
                menus?.[key]?.onClick?.()
            }}
            activeTab={activeTab?.toString()}
            >
                {
                    menus?.map((v, index) => {
                        return <TabsButton key={index} className={styles.item}>
                            {v.text}
                        </TabsButton>
                    })
                }
            </Tabs>
        </div>
    </div>
}

export default TopMenu